import * as React from 'react';
import { RadioButton, Summary } from '@grandvisionhq/common';
import { Hr, Label } from '@grandvisionhq/elements';

const SelectAddress = ({ addressSummaryElement , handleChange , hasPreferredTag , id , isPreferredBillingAddress , isPreferredDeliveryAddress , labels , selected ,  })=>{
     return React.createElement(RadioButton, {
        key: id,
        value: id,
        isChecked: id === (selected === null || selected === void 0 ? void 0 : selected.id),
        onChange: handleChange,
        className: "select-address__item"
    }, /*#__PURE__*/ React.createElement(Summary, {
        className: "select-address__summary"
    }, addressSummaryElement), hasPreferredTag && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement("div", {
        className: "select-address__tags"
    }, isPreferredBillingAddress && /*#__PURE__*/ React.createElement(Label, {
        type: "info",
        className: "select-address__tag"
    }, labels.preferredBilling), isPreferredDeliveryAddress && /*#__PURE__*/ React.createElement(Label, {
        type: "info",
        className: "select-address__tag"
    }, labels.preferredShipping))));
};

export { SelectAddress };
//# sourceMappingURL=SelectAddress.js.map
